import * as React from "react";

const fields = (t) => ({

    config: {columns: 1},
    fields: [
        {
            name: "id",
            label: t ? t("common.id") : "ID",
            readOnly: true,
            column: 1,
        },
        {
            name: "position",
            label: t ? t("common.position") : "Położenie",
            column: 1,
        },
        {
            name: "partNumber",
            column: 1,
            label: t ? t("common.number") : "Numer",
        }
    ]

});

export default fields;
